import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';
Vue.use(Router);
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'Dashboard', icon: 'dashboard' },
      },
    ],
  },
];

export const asyncRoutes = [
  {
    path: '/companies',
    component: Layout,
    name: 'Companies',
    redirect: '/companies/list',
    meta: { title: '經銷商', icon: 'el-icon-s-home' },
    children: [
      {
        path: '/companies/list',
        name: 'CompaniesList',
        component: () => import('@/views/companies/list'),
        meta: {
          title: '經銷商列表',
          icon: 'el-icon-s-home',
          action: { c: false, r: false, u: false, d: false, e: false },
        },
      },
    ],
  },

  {
    path: '/clients',
    component: Layout,
    name: 'Clients',
    redirect: '/clients/list',
    meta: { title: '客戶', icon: 'el-icon-s-goods' },
    children: [
      {
        path: '/clients/list',
        name: 'ClientsList',
        component: () => import('@/views/clients/list'),
        meta: {
          title: '客戶列表',
          icon: 'el-icon-goods',
          action: { c: false, r: false, u: false, d: false, e: false },
        },
      },
    ],
  },
  {
    path: '/mvms',
    component: Layout,
    name: 'Mvms',
    redirect: '/mvms/list',
    meta: {
      title: '機台資產管理',
      icon: 'el-icon-s-platform',
      roles: ['admin'],
    },
    children: [
      {
        path: 'mvms/list',
        name: 'MvmsList',
        component: () => import('@/views/mvms/list'),
        meta: {
          title: '機台一覽',
          icon: 'el-icon-cpu',
          roles: ['admin'],
          action: { c: false, r: false, u: false, d: false },
        },
      },

      {
        path: 'map',
        name: 'MvmsMap',
        component: () => import('@/views/mvms/map'),
        meta: {
          title: '機台地圖',
          icon: 'el-icon-map-location',
          roles: ['admin'],
          action: { c: false, r: false, u: false, d: false },
        },
      },
    ],
  },
  {
    path: '/users',
    component: Layout,
    name: 'Users',
    redirect: '/users/list',
    meta: { title: '權限管理', icon: 'el-icon-lock', roles: ['admin'] },
    children: [
      {
        path: 'list',
        name: 'UsersList',
        component: () => import('@/views/users/list'),
        meta: {
          title: '使用者管理',
          icon: 'user',
          roles: ['admin'],
          action: { c: false, r: false, u: false, d: false },
        },
      },
    ],
  },
  {
    path: '/transaction',
    component: Layout,
    name: 'Transaction',
    redirect: '/transaction/summary',
    meta: { title: '交易管理', icon: 'el-icon-data-analysis' },
    children: [
      {
        path: 'summary',
        name: 'TransactionSummary',
        component: () => import('@/views/transaction/summary'),
        meta: {
          title: '銷售彙總',
          icon: 'el-icon-pie-chart',
          action: { c: false, r: false, u: false, d: false },
        },
      },
      {
        path: 'sales',
        name: 'TransactionSales',
        component: () => import('@/views/transaction/sales'),
        meta: {
          title: '銷售紀錄',
          icon: 'el-icon-s-marketing',
          action: { c: false, r: false, u: false, d: false, e: false },
        },
      },
    ],
  },
  {
    path: '/products',
    component: Layout,
    name: 'Products',
    redirect: '/products/list',
    meta: { title: '商品', icon: 'el-icon-s-goods' },
    children: [
      {
        path: '/products/list',
        name: 'ProductsList',
        component: () => import('@/views/products/list'),
        meta: {
          title: '商品一覽',
          icon: 'el-icon-goods',
          action: { c: false, r: false, u: false, d: false, e: false },
        },
      },
      {
        path: '/product/manage',
        name: 'ProductManage',
        component: () => import('@/views/products/manage'),
        meta: {
          title: '新增商品',
          icon: 'el-icon-setting',
          action: { c: false, r: false, u: false, d: false },
        },
      },
    ],
  },

  {
    path: '/easycard',
    component: Layout,
    name: 'Easycard',
    redirect: '/easycard/index',
    meta: { title: '悠遊卡', icon: 'el-icon-bank-card' },
    children: [
      {
        path: '/easycard/index',
        name: 'EasycardIndex',
        component: () => import('@/views/easycard/index'),
        meta: {
          title: '悠遊卡',
          icon: 'el-icon-bank-card',
          action: { c: false, r: false, u: false, d: false, e: false },
        },
      },
    ],
  },

  {
    path: '/invoice',
    component: Layout,
    name: 'Invoice',
    redirect: '/invoice/list',
    meta: { title: '發票', icon: 'el-icon-tickets' },
    children: [
      {
        path: '/invoice/list',
        name: 'InvoiceList',
        component: () => import('@/views/invoice/list'),
        meta: {
          title: '發票一覽',
          icon: 'el-icon-document',
          action: { c: false, r: false, u: false, d: false },
        },
      },
      {
        path: '/invoice/manage',
        name: 'InvoiceManage',
        component: () => import('@/views/invoice/manage'),
        meta: {
          title: '發票管理',
          icon: 'el-icon-setting',
          action: { c: false, r: false, u: false, d: false },
        },
      },
    ],
  },

  {
    path: '/replenish',
    component: Layout,
    name: 'Replenish',
    redirect: '/replenish/index',
    meta: { title: '機台設定', icon: 'el-icon-mobile-phone' },
    children: [
      {
        path: '/replenish/deploy',
        name: 'Deploy',
        component: () => import('@/views/replenish/deploy'),
        meta: {
          title: '機台註冊',
          icon: 'el-icon-circle-plus',
          action: { c: false, r: false, u: false, d: false },
        },
      },
      {
        path: '/replenish/myMvm',
        name: 'MyMvm',
        component: () => import('@/views/replenish/myMvm'),
        meta: {
          title: '我的機台',
          icon: 'el-icon-s-operation',
          action: { c: false, r: false, u: false, d: false },
        },
      },
    ],
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true,
    name: '404',
    meta: { title: '404' },
  },
];
const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });
const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
